import { ApiTypes, api } from "../common";

const CATEGORIES_PATHS: ApiTypes.API = {
  featured: {
    path: `api/products/category/`,
    method: ApiTypes.HTTPMethod.GET,
  },
};

export const getCategories = async (category_id?: number) => {
  const endpoint = CATEGORIES_PATHS.featured;

  const response = await api({
    method: endpoint.method,
    url: `${endpoint.path}${category_id}`,
  });
  return response.data;
};
